module.exports = __webpack_public_path__ + "img/coinbankB17.5a333f96.jpg";